export default function (){
    let excluded = ['searchMode'];

    excluded.push((dataholder.searchMode === dataholder.searchModes.miniferie) ? 'ankomst' : 'dateRange' );
    excluded.push('specificAnkomst');
    excluded.push('useSpecificArrival');
    if(dataholder.searchMode === dataholder.searchModes.miniferie)
        excluded.push('duration');

    return excluded;
}
